// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file penumbra/core/component/community_pool/v1/community_pool.proto (package penumbra.core.component.community_pool.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { CommunityPoolAssetBalancesRequest, CommunityPoolAssetBalancesResponse } from "./community_pool_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Query operations for the community_pool component.
 *
 * @generated from service penumbra.core.component.community_pool.v1.QueryService
 */
export const QueryService = {
    typeName: "penumbra.core.component.community_pool.v1.QueryService",
    methods: {
        /**
         * @generated from rpc penumbra.core.component.community_pool.v1.QueryService.CommunityPoolAssetBalances
         */
        communityPoolAssetBalances: {
            name: "CommunityPoolAssetBalances",
            I: CommunityPoolAssetBalancesRequest,
            O: CommunityPoolAssetBalancesResponse,
            kind: MethodKind.ServerStreaming,
        },
    }
};
